module.exports = __webpack_public_path__ + "img/logo-infop-virtual.332f1b5d.png";